import { tickerConstants } from '../_constants';

export function ticker(state = {}, action) {
  switch (action.type) {
    case tickerConstants.GETTICKER_SUCCESS:
      return { 
        tickerinfo : action.tickerinfo , 
        loading : false
      };
    case tickerConstants.GETTICKER_FAILURE:
      return {
        loading : false
      };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/ticker.reducer.js